module.exports = __webpack_public_path__ + "static/img/image1.77511003.png";